module.exports = __webpack_public_path__ + "static/media/blacklinkedin.9f03b54a.png";